<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-2">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>
        <div class="mb-6">
          <label class="label-input">Section Background</label>
          <div class="group-item">
            <div>
              <label class="label-input mb-0">Padding </label>
              <v-row>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
                  </div>
                </v-col>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col md="6" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="textColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['colors'].textColor" label="Text Color" />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="backgroundColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['colors'].backgroundColor" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mb-6">
          <label class="label-input">Header</label>
          <div class="group-item">
            <div class="mb-4">
              <v-text-field v-model="fields['breadcrumb']" label="Breadcrumb" />
            </div>
            <div class="mb-6">
              <label class="label-input">Title</label>
              <ckeditor :editor="editor" v-model="fields.postTitle" :config="editorConfig" />
            </div>
            <div class="mb-6">
              <label class="label-input">Author</label>
              <v-text-field v-model="fields['author'].name" label="Name" />
              <p>Avatar</p>
              <div class="mt-6">
                <UploadImage
                  @callback="handleUploadImage"
                  :image="{ imageSrc: fields['author'].avatar }"
                  :height="`150`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImage"
                />
              </div>
              <v-text-field class="mt-6" v-model="fields['createdAt']" label="Created At" />
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="borderColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].borderColor"
                  @change="handleChangeBorderColor"
                />
                <v-text-field v-model="fields['colors'].borderColor" label="Border Color" />
                <v-btn @click="handleResetBorderColor" small text color="primary"> Reset </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-6">
          <label class="label-input">Summary</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.summary.text" :config="editorConfig" />
            <v-row class="mt-2">
              <v-col md="6" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="summaryTextColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['summary'].textColor"
                    @change="handleChangeSummaryTextColor"
                  />
                  <v-text-field v-model="fields['summary'].textColor" label="Summary Text Color" />
                  <v-btn @click="handleResetSummaryTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="summaryBackgroundColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['summary'].backgroundColor"
                    @change="handleChangeSummaryBackgroundColor"
                  />
                  <v-text-field v-model="fields['summary'].backgroundColor" label="Summary Background Color" />
                  <v-btn @click="handleResetSummaryBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mb-6">
          <label class="label-input">Content</label>
          <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';

export default {
  name: 'post-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        postTitle: '',
        breadcrumb: 'Toy > Family Gift Toys > Kid & Pet Interactive Toys',
        summary: {
          text: '',
          backgroundColor: '#EAFDD7',
          textColor: '#000000',
        },
        author: {
          name: 'Elysia F.',
          avatar: 'https://cdn.latteprint.com/latte/2025-08-22/1755856692811-79.jpg',
        },
        content: '',
        createdAt: '12/12/2025',
        colors: {
          backgroundColor: '#ffffff',
          textColor: '#000000',
          borderColor: '#e5e7eb',
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields['author'].avatar = obj.imageSrc;
    },
    handleRemoveImage() {
      this.fields['author'].avatar = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['colors'].backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['colors'].backgroundColor = '#ffffff';
    },
    handleChangeTextColor(event) {
      this.fields['colors'].textColor = event.target.value;
    },
    handleResetTextColor() {
      this.fields['colors'].textColor = '#000000';
    },
    handleChangeBorderColor(event) {
      this.fields['colors'].borderColor = event.target.value;
    },
    handleResetBorderColor() {
      this.fields['colors'].borderColor = '#e5e7eb';
    },
    handleChangeSummaryTextColor(event) {
      this.fields['summary'].textColor = event.target.value;
    },
    handleResetSummaryTextColor() {
      this.fields['summary'].textColor = '#000000';
    },
    handleChangeSummaryBackgroundColor(event) {
      this.fields['summary'].backgroundColor = event.target.value;
    },
    handleResetSummaryBackgroundColor() {
      this.fields['summary'].backgroundColor = '#EAFDD7';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionPost(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 150px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 150px !important;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.post-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 500;
}
.comment-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
